import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-sm">
      {items.map((item, idx) => (
        <span key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
          {idx > 0 && <i className="ri-arrow-right-s-line text-base text-foreground-400"></i>}
          {item.to ? (
            <Link
              to={item.to}
              className="text-foreground-500 transition-colors hover:text-primary-600 cursor-pointer"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}